<template>
  <div>
    <button type="button" @click.prevent="doAction" class="player-button">{{title}}</button>
  </div>
</template>
<script>
import { showLoginPopup, showVoucherPopup } from '@/common/utils/scalable.player'

const ACTION_STATE = {
  LOGIN: 'login',
  STREAM: 'stream',
  PURCHASE: 'purchase',
  NONE: 'none'
}
export default {
  name: 'PlayerActionButton',
  props: {
    contentType: {
      type: String
    },
    contentInfo: {
      type: Object
    },
    title: {
      type: String
    },
    action: {
      type: String
    }
  },
  methods: {
    doAction () {
      switch (this.action) {
        case ACTION_STATE.LOGIN :
          showLoginPopup()
          break
        case ACTION_STATE.STREAM:
          window.playerInstance.play()
          break
        case ACTION_STATE.PURCHASE:
          showVoucherPopup({ type: this.contentType, contentInfo: this.contentInfo })
          break
        case ACTION_STATE.NONE:
          break
      }
    }
  }
}
</script>
